<script lang="ts" setup>
import DropdownItem from '#components/elements/dropdown/DropdownItem.vue';
import DropdownMenu from '#components/elements/dropdown/DropdownMenu.vue';
import { useKpisPerimeter } from '#composables/kpisPerimeter';
import { useLanguage } from '#composables/useLanguage';
import { TAX_VALUES } from '#helpers';
import { computed } from 'vue';

const { t } = useLanguage();
const {
  taxonomy: { taxonomy },
  withTax: { isWithTax, updateIsWithTax }
} = useKpisPerimeter();

const taxDropdownDisabledInfoMessage = computed(() => {
  if (taxonomy.value === 'nielsen') {
    return t('performanceCarrefourCatman.salesAmountFormat.nielsenIsWithTax');
  }

  return null;
});

const isTTC = computed(() => (isWithTax.value ? TAX_VALUES.TTC : TAX_VALUES.HT));
const changeTTC = async (value: string) => {
  await updateIsWithTax(value === TAX_VALUES.TTC);
};
</script>

<template>
  <DropdownMenu
    :no-padding="true"
    background="outline"
    variant="default"
    :disabled="!!taxDropdownDisabledInfoMessage"
    :popover="taxDropdownDisabledInfoMessage ?? undefined"
  >
    <span class="text-default-disabled">
      {{ t('commonLabel.value') }}
    </span>
    <span class="text-black">{{ t(`performanceCarrefourCatman.salesAmountFormat.${isTTC}`) }}</span>

    <template #items>
      <DropdownItem
        v-for="item in [
          {
            value: TAX_VALUES.TTC,
            label: t('performanceCarrefourCatman.salesAmountFormat.TTC')
          },
          {
            value: TAX_VALUES.HT,
            label: t('performanceCarrefourCatman.salesAmountFormat.HT')
          }
        ]"
        :key="item.value"
        @click="changeTTC(item.value)"
      >
        <button v-if="isTTC !== item.value">
          {{ item.label }}
        </button>
        <strong v-else>{{ item.label }} </strong>
      </DropdownItem>
    </template>
  </DropdownMenu>
</template>
